import EventDate from './EventDate';
import EventDatePastBagde from './EventDatePastBagde';
import isNotAPastEvent from './isNotAPastEvent';

export default function EventDateInfo({
  publishDate,
  dates,
}) {
  const showPastEventBadge = isNotAPastEvent(dates, publishDate) === false;

  return (
    <div className="flex items-center w-full">
      <div className="flex items-center space-x-4 flex-1">
        {showPastEventBadge && (<EventDatePastBagde />)}
        <EventDate date={publishDate} />
      </div>
    </div>
  );
}
